/* PulloraX header: predictive search, recent searches, mega-menu, mobile accordion.

   Search behaviour, rewritten to match how people actually search this
   catalogue.

   1. The previous build treated ANY query containing a digit as a set code and
      filtered the suggestions down to a compacted substring match. That killed
      the most common real queries: "151 booster box", "mega brave 2025" and
      "op 13 box" all returned "No exact match found" while the products sat
      right there. Strict matching now applies only to a genuinely code-shaped
      query - one token, no space, letters AND digits, ten characters or fewer -
      so "sv2a" is strict and "151 booster box" is not.

   2. The dropdown searched products only, so "customs", "shipping", "returns"
      and even "booster box" as a category returned nothing. It now asks for
      products, collections and pages, and renders them as three labelled
      groups.

   3. limit_scope=each is REQUIRED once more than one resource type is asked
      for. Without it Shopify treats resources[limit] as the total across ALL
      types, so a search for "booster" came back with two products, two
      collections and a page - six rows in total, which looked like the
      catalogue only had two booster boxes. With limit_scope=each the limit
      applies per type, and products get their own six.

   4. Product suggestions also search the product body, because the product
      descriptions carry the set name, the franchise and the product type in the
      words a buyer would type.

   5. RECENT SEARCHES. A visitor who searched a set, left the page and came back
      had to type it again. The last six queries are kept in this browser's
      localStorage and offered the moment the field is focused and empty. It is
      per-browser and per-device by design: nothing is sent to us, nothing is
      tied to an account, and Clear removes it. A private window or cleared site
      data simply starts empty, which is why every read and write is wrapped -
      some browsers throw on access rather than returning null.

   6. LANGUAGE. This file is a static asset and cannot read Liquid, so every
      string it prints is handed to it as a data- attribute on the search form
      by sections/pullorax-header.liquid. Before that the dropdown answered in
      English on /fr and /de.

   7. ACCESSIBILITY - the ARIA 1.2 combobox pattern (WCAG 4.1.2).
      Arrow-key selection used to be a CSS class and nothing else: no option
      ids, no aria-activedescendant, no aria-selected. A screen-reader user
      pressed Down, heard nothing, pressed Enter and was taken somewhere they
      had never been told about. Now:
        - the input carries aria-autocomplete="list" and, while a row is
          active, aria-activedescendant pointing at that row's id;
        - every selectable row is role="option" with a unique id and an
          explicit aria-selected, true on the active row and false on the rest;
        - DOM focus NEVER leaves the input - the visitor keeps typing while
          arrowing, exactly as before;
        - aria-expanded is set in openBox/closeBox only, so it is true when and
          only when the panel is displayed;
        - the panel is role="listbox", and a listbox may only own options and
          groups. The headings and the Clear button are not options, so each
          .px-sg__grp is now role="group" carrying the heading text as its
          aria-label and the visible heading is aria-hidden. Nothing moved in
          the DOM, so the layout is untouched.

   Nothing here is invented: everything rendered comes back from
   /search/suggest.json, and an empty result offers the full search page rather
   than a dead end. */
(function () {
  'use strict';
  var input = document.getElementById('pxSearch');
  var box = document.getElementById('pxSuggest');
  if (input && box) {
    var form = input.closest('form');
    var d = (form && form.dataset) || {};
    var T = {
      recent: d.pxTRecent || 'Recent searches',
      clear: d.pxTClear || 'Clear',
      products: d.pxTProducts || 'Products',
      categories: d.pxTCategories || 'Categories',
      pages: d.pxTPages || 'Help pages',
      available: d.pxTAvailable || 'Available',
      soldOut: d.pxTSoldout || 'Sold out',
      talk: d.pxTTalk || 'Talk to us',
      noMatch: d.pxTNomatch || 'No match for',
      searchAll: d.pxTSearchall || 'Search the full catalogue',
      seeAll: d.pxTSeeall || 'See all results for',
      browseCat: d.pxTBrowsecat || 'Browse the category',
      infoPage: d.pxTInfopage || 'Information page'
    };

    var timer, controller;
    // LOCALE + MONEY (QA fix 9 Oct 2026, functional.md #7). The form carries
    // routes.root_url, routes.search_url and shop.money_format as data-
    // attributes. Every request and every link stays under the visitor's
    // language prefix (/he, /fr ...), and prices use the shop's own money
    // format - the same substitution as snippets/pullorax-cart-drawer - instead
    // of Intl, which printed "95.99 US$" on /he and "95,99 $US" on /fr.
    var root = String(d.pxRoot || '/');
    if (root.charAt(root.length - 1) !== '/') root += '/';
    var prefix = root === '/' ? '' : root.slice(0, -1);
    var searchUrl = d.pxSearchUrl || (prefix + '/search');
    var moneyFmt = d.pxMoneyFormat || '${{amount}}';
    var money = function (value) {
      if (value == null || String(value).trim() === '') return '';
      var n = Number(value);
      if (!Number.isFinite(n) || n < 0) return '';
      var dec, whole;
      try { dec = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); } catch (e) { dec = n.toFixed(2); }
      try { whole = Math.round(n).toLocaleString('en-US'); } catch (e) { whole = String(Math.round(n)); }
      return String(moneyFmt).replace(/\{\{\s*amount_no_decimals[a-z_]*\s*\}\}/g, whole).replace(/\{\{\s*amount[a-z_]*\s*\}\}/g, dec);
    };
    // A suggestion URL that comes back without the language prefix is given it,
    // so a click never drops the shopper onto the English site.
    var localUrl = function (u) {
      u = String(u || '');
      if (!prefix || u.charAt(0) !== '/' || u.charAt(1) === '/') return u;
      if (u === prefix || u.indexOf(prefix + '/') === 0 || u.indexOf(prefix + '?') === 0) return u;
      return prefix + u;
    };
    var ESC = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
    var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ESC[c]; }); };
    var compact = function (s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ''); };
    var fullUrl = function (q) { return searchUrl + '?q=' + encodeURIComponent(q) + '&type=product,page&options%5Bprefix%5D=last'; };
    var optId = function (i) { return 'pxSg-' + i; };

    // ---- recent searches -------------------------------------------------
    // Per browser, never sent anywhere. Wrapped because some browsers throw on
    // storage access rather than returning null.
    var KEY = 'px:recent';
    var MAX = 6;
    function recentGet() {
      try {
        var raw = window.localStorage.getItem(KEY);
        var list = raw ? JSON.parse(raw) : [];
        return Object.prototype.toString.call(list) === '[object Array]' ? list.slice(0, MAX) : [];
      } catch (e) { return []; }
    }
    function recentAdd(q) {
      q = String(q || '').trim();
      if (q.length < 2) return;
      try {
        var list = recentGet().filter(function (x) { return String(x).toLowerCase() !== q.toLowerCase(); });
        list.unshift(q);
        window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
      } catch (e) {}
    }
    function recentClear() {
      try { window.localStorage.removeItem(KEY); } catch (e) {}
    }

    // ---- combobox active option ------------------------------------------
    // DOM focus stays on the input at all times. The active row is pointed at
    // with aria-activedescendant and marked aria-selected, which is what a
    // screen reader announces; .is-sel remains the purely visual half.
    function rowsOf() { return box.querySelectorAll('.px-sg__row'); }
    function clearActive() {
      var rows = rowsOf();
      for (var j = 0; j < rows.length; j++) { rows[j].classList.remove('is-sel'); rows[j].setAttribute('aria-selected', 'false'); }
      input.removeAttribute('aria-activedescendant');
    }
    function setActive(rows, idx) {
      for (var j = 0; j < rows.length; j++) { rows[j].classList.remove('is-sel'); rows[j].setAttribute('aria-selected', 'false'); }
      var row = rows[idx];
      if (!row) { input.removeAttribute('aria-activedescendant'); return; }
      row.classList.add('is-sel');
      row.setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', row.id);
      row.scrollIntoView({ block: 'nearest' });
    }
    // aria-expanded is set in these two functions and nowhere else, so it can
    // never disagree with whether the panel is on screen. Freshly rendered rows
    // are always inactive, so the pointer is dropped on the way in as well.
    function openBox() { box.classList.add('is-on'); input.removeAttribute('aria-activedescendant'); input.setAttribute('aria-expanded', 'true'); }
    function closeBox() { box.classList.remove('is-on'); input.setAttribute('aria-expanded', 'false'); clearActive(); }

    function renderRecent() {
      var list = recentGet();
      if (!list.length) { closeBox(); return; }
      var html = '<div class="px-sg__grp" role="group" aria-label="' + esc(T.recent) + '">' +
        '<div class="px-sg__hrow"><div class="px-sg__head" aria-hidden="true">' + esc(T.recent) + '</div>' +
        '<button type="button" class="px-sg__clear" data-px-recent-clear>' + esc(T.clear) + '</button></div>' +
        list.map(function (q, i) {
          return '<a class="px-sg__row px-sg__row--recent" id="' + optId(i) + '" role="option" aria-selected="false" href="' + esc(fullUrl(q)) + '" data-i="' + i + '" data-px-recent-q="' + esc(q) + '">' +
            '<svg class="px-sg__rc" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>' +
            '<b>' + esc(q) + '</b></a>';
        }).join('') + '</div>';
      box.innerHTML = html;
      openBox();
    }

    function productRow(p, i) {
      var img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
      var price = !p.available ? '' : (p.price_html != null ? String(p.price_html) : (p.price_min != null ? money(p.price_min) : (p.price != null ? money(p.price) : '')));
      var stock = p.available ? T.available : T.talk;
      return '<a class="px-sg__row" id="' + optId(i) + '" role="option" aria-selected="false" href="' + esc(localUrl(p.url)) + '" data-i="' + i + '">' +
        (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '<span class="px-sg__ph"></span>') +
        '<span><b>' + esc(p.title) + '</b><span class="m">' + esc(p.type || '') + (p.type ? ' &middot; ' : '') + esc(stock) + '</span></span>' +
        (price ? '<span class="p">' + esc(price) + '</span>' : '<span></span>') + '</a>';
    }

    function plainRow(item, i, note) {
      return '<a class="px-sg__row px-sg__row--plain" id="' + optId(i) + '" role="option" aria-selected="false" href="' + esc(localUrl(item.url)) + '" data-i="' + i + '">' +
        '<b>' + esc(item.title) + '</b><span class="m">' + esc(note) + '</span></a>';
    }

    // A listbox may only own options and groups, so every heading travels
    // inside a role="group" whose aria-label carries the same words. The
    // visible heading is hidden from assistive tech to avoid saying it twice.
    function groupOpen(label) {
      return '<div class="px-sg__grp" role="group" aria-label="' + esc(label) + '">' +
        '<div class="px-sg__head" aria-hidden="true">' + esc(label) + '</div>';
    }

    // A code query is one token carrying both letters and digits - sv2a, s12a,
    // op-13. A set NAME that happens to be a number, like 151, is not a code.
    function isCodeQuery(q) {
      if (!q || q.indexOf(' ') !== -1) return false;
      if (q.length > 10) return false;
      return /[0-9]/.test(q) && /[a-z]/i.test(q);
    }

    function render(res, q) {
      var products = (res && res.products) || [];
      var collections = ((res && res.collections) || []).slice(0, 3);
      var pages = ((res && res.pages) || []).slice(0, 3);

      if (isCodeQuery(q)) {
        var cq = compact(q);
        products = products.filter(function (p) {
          var variants = (p.variants || []).map(function (v) { return (v.title || '') + ' ' + (v.sku || ''); }).join(' ');
          return compact((p.title || '') + ' ' + (p.url || '') + ' ' + (p.type || '') + ' ' + variants).indexOf(cq) !== -1;
        });
      }

      var html = '';
      var i = 0;
      if (products.length) {
        html += groupOpen(T.products) +
          products.map(function (p) { return productRow(p, i++); }).join('') + '</div>';
      }
      if (collections.length) {
        html += groupOpen(T.categories) +
          collections.map(function (c) { return plainRow(c, i++, T.browseCat); }).join('') + '</div>';
      }
      if (pages.length) {
        html += groupOpen(T.pages) +
          pages.map(function (p) { return plainRow(p, i++, T.infoPage); }).join('') + '</div>';
      }

      if (!html) {
        html = '<div class="px-sg__empty" role="group">' + esc(T.noMatch) + ' &ldquo;' + esc(q) + '&rdquo;. <a href="' + esc(fullUrl(q)) + '">' + esc(T.searchAll) + '</a></div>';
      } else {
        html += '<a class="px-sg__row px-sg__row--plain px-sg__all" id="' + optId(i) + '" role="option" aria-selected="false" href="' + esc(fullUrl(q)) + '" data-i="' + i + '"><b>' + esc(T.seeAll) + ' &ldquo;' + esc(q) + '&rdquo;</b></a>';
      }
      box.innerHTML = html;
      openBox();
    }

    // The locale's own suggest.json first: it answers in the visitor's language
    // with prefixed URLs on /fr /de /it /es. On /he it answers 417 "Unsupported
    // buyer locale", so any non-OK answer falls back to the section
    // pullorax-search-suggest, rendered by Liquid in the visitor's language.
    function suggestFallback(q, signal) {
      var url = searchUrl + '?q=' + encodeURIComponent(q) + '&type=product,page&options%5Bprefix%5D=last&section_id=pullorax-search-suggest';
      return fetch(url, { signal: signal })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var m = /<script type="application\/json" data-px-sg-json>([\s\S]*?)<\/script>/.exec(html || '');
          return m ? JSON.parse(m[1]) : {};
        });
    }

    function search(q) {
      if (controller) controller.abort(); controller = new AbortController();
      var signal = controller.signal;
      var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,page' +
        '&resources[limit]=6' +
        '&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,body,variants.title,variants.sku,tag';
      fetch(url, { signal: signal })
        .then(function (r) {
          if (!r.ok) return suggestFallback(q, signal);
          return r.json().then(function (data) { return (data.resources && data.resources.results) || {}; });
        })
        .then(function (results) { if (!signal.aborted) render(results || {}, q); })
        .catch(function () {});
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { renderRecent(); return; }
      timer = setTimeout(function () { search(q); }, 160);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length < 2) renderRecent();
    });

    // Remember what was actually searched: a submitted query, and a suggestion
    // the visitor clicked through to.
    if (form) {
      form.addEventListener('submit', function () { recentAdd(input.value); });
    }
    box.addEventListener('click', function (e) {
      var clear = e.target.closest('[data-px-recent-clear]');
      if (clear) { e.preventDefault(); recentClear(); closeBox(); input.focus(); return; }
      var row = e.target.closest('.px-sg__row');
      if (row) { recentAdd(row.getAttribute('data-px-recent-q') || input.value); }
    });

    input.addEventListener('keydown', function (e) { var rows = rowsOf(); if (!rows.length) return; var sel = box.querySelector('.px-sg__row.is-sel'); var idx = sel ? parseInt(sel.dataset.i, 10) : -1; if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); idx = e.key === 'ArrowDown' ? (idx + 1) % rows.length : (idx - 1 + rows.length) % rows.length; setActive(rows, idx); } else if (e.key === 'Enter' && sel) { e.preventDefault(); recentAdd(sel.getAttribute('data-px-recent-q') || input.value); window.location.href = sel.getAttribute('href'); } else if (e.key === 'Escape') { closeBox(); } });
    document.addEventListener('click', function (e) { if (!e.target.closest('.px-hdr__search')) { closeBox(); } });
  }

  // ---- shop menu ---------------------------------------------------------
  // The old build opened the panel on mouseenter and closed it on mouseleave
  // with no delay at all. The panel hangs below the button with a gap between
  // them, so moving the pointer down towards the panel left the item for a
  // moment, mouseleave fired, and the menu shut in the visitor's face - then
  // reopened as soon as the pointer touched the button again. Clicking made it
  // worse: mouseenter had already opened the panel, so the click toggled it
  // shut.
  //
  // Now:
  //   - hover opens after a short intent delay and closes after a grace delay,
  //     so crossing the gap is survivable;
  //   - a CLICK PINS the panel open and hover can no longer close it. A pinned
  //     panel closes on a second click on the button, a click outside, Escape,
  //     or when keyboard focus leaves it.
  // The gap itself is bridged by an invisible strip above the panel, in the
  // stylesheet of sections/pullorax-header.liquid.
  var navItems = Array.prototype.slice.call(document.querySelectorAll('[data-px-nav]'));
  var navOpenT, navCloseT;

  function navSet(it, on) {
    it.classList.toggle('is-on', on);
    var b = it.querySelector('.px-nav__btn');
    if (b) b.setAttribute('aria-expanded', String(on));
    if (!on) it.removeAttribute('data-px-pinned');
  }

  function closeNav(except) {
    navItems.forEach(function (it) { if (it !== except) navSet(it, false); });
  }

  navItems.forEach(function (it) {
    var btn = it.querySelector('.px-nav__btn');
    if (!btn) return;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      clearTimeout(navOpenT);
      clearTimeout(navCloseT);
      var pinned = it.hasAttribute('data-px-pinned');
      closeNav(it);
      if (pinned) {
        navSet(it, false);
      } else {
        navSet(it, true);
        it.setAttribute('data-px-pinned', '');
      }
    });

    it.addEventListener('mouseenter', function () {
      clearTimeout(navCloseT);
      navOpenT = setTimeout(function () { closeNav(it); navSet(it, true); }, 90);
    });

    it.addEventListener('mouseleave', function () {
      clearTimeout(navOpenT);
      if (it.hasAttribute('data-px-pinned')) return;
      navCloseT = setTimeout(function () { navSet(it, false); }, 320);
    });

    it.addEventListener('focusout', function (e) {
      if (e.relatedTarget && it.contains(e.relatedTarget)) return;
      navSet(it, false);
    });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-px-nav]')) closeNav(null);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeNav(null); });

  var burger = document.getElementById('pxBurger'); var drawer = document.getElementById('pxDrawer');
  // QA 9 Oct 2026 (mobile.md#14, code-a11y.md#6): focus moves into the menu when it opens; Escape
  // and the close button at the end of the menu close it and hand focus back to the burger.
  function drawerSet(on, back) {
    if (on) drawer.removeAttribute('hidden'); else drawer.setAttribute('hidden', '');
    burger.setAttribute('aria-expanded', String(on));
    if (on) { var f = drawer.querySelector('a[href], button:not([disabled])'); if (f) f.focus({ preventScroll: true }); }
    else if (back) { burger.focus({ preventScroll: true }); var r = burger.getBoundingClientRect(); if (r.bottom < 0 || r.top > window.innerHeight) burger.scrollIntoView({ block: 'center' }); }
  }
  if (burger && drawer) {
    burger.addEventListener('click', function () { drawerSet(drawer.hasAttribute('hidden'), false); });
    var dClose = drawer.querySelector('[data-px-drawer-close]');
    if (dClose) dClose.addEventListener('click', function () { drawerSet(false, true); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hasAttribute('hidden')) drawerSet(false, true); });
  }
  Array.prototype.slice.call(document.querySelectorAll('[data-px-acc]')).forEach(function (btn) { btn.addEventListener('click', function () { var panel = btn.nextElementSibling; if (!panel) return; var open = !panel.hasAttribute('hidden'); if (open) { panel.setAttribute('hidden', ''); } else { panel.removeAttribute('hidden'); } btn.setAttribute('aria-expanded', String(!open)); }); });
  // MOBILE TAB MENUS (15 Oct 2026, owner). SHOP / MAGAZINE / WHOLESALE each open
  // their own menu under the tab row (sections/pullorax-header.liquid). A tab keeps
  // its href, so without this script it still goes to its page. One menu at a time;
  // a second tap on the open tab, a tap outside, Escape or the burger closes it.
  var mtTabs = Array.prototype.slice.call(document.querySelectorAll('[data-px-mt]'));
  function mtPanel(t) { return document.getElementById(t.getAttribute('data-px-mt')); }
  function mtClose(back) {
    mtTabs.forEach(function (t) {
      var p = mtPanel(t);
      if (p && !p.hasAttribute('hidden')) {
        p.setAttribute('hidden', '');
        if (back) t.focus({ preventScroll: true });
      }
      t.setAttribute('aria-expanded', 'false');
    });
  }
  mtTabs.forEach(function (t) {
    var p = mtPanel(t);
    if (!p) return;
    t.addEventListener('click', function (e) {
      // desktop never shows the tab row; a hidden tab cannot be clicked, but stay safe
      if (window.matchMedia && window.matchMedia('(min-width: 901px)').matches) return;
      e.preventDefault();
      var open = !p.hasAttribute('hidden');
      mtClose(false);
      if (!open) {
        if (drawer && !drawer.hasAttribute('hidden') && burger) drawerSet(false, false);
        p.removeAttribute('hidden');
        t.setAttribute('aria-expanded', 'true');
      }
    });
  });
  if (mtTabs.length) {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-px-mt]') || e.target.closest('.px-mpanel')) return;
      mtClose(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var openTab = mtTabs.filter(function (t) { return t.getAttribute('aria-expanded') === 'true'; })[0];
      if (openTab) mtClose(true);
    });
    if (burger) burger.addEventListener('click', function () { mtClose(false); });
    Array.prototype.slice.call(document.querySelectorAll('[data-px-mt-close]')).forEach(function (b) {
      b.addEventListener('click', function () { mtClose(true); });
    });
  }
})();